import { Button } from '../../../Utility/Button';
import useChatModels from '../../../../Hooks/useChatModels';
import AdminViewHeader from '../../../Utility/AdminViewHeader';
import AdminViewContent from '../../../Utility/AdminViewContent';
import { Model } from '../../../../Types';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import { PaginationWrapper } from '../../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { modelService } from '../../../../Services/modelService';
import useGlobals from '../../../../Hooks/useGlobals';
import useSearchFilter from '../../../../Hooks/useSearchFilter';
import SearchFilter from '../../../Utility/SearchFilter';

function ChatModels() {
    const { userSettings } = useGlobals();
    const { ModelsActions, handleNavigate, i18n, settings, windowWidth, getBreakpoint } = useChatModels();
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <>
            <SearchFilter
                value={localQuery}
                onChange={searchActions.setLocalQuery}
                onApply={searchActions.applyQuery}
                onClear={searchActions.clearQuery}
            />
            <div className="mb-4 md:hidden">
                {(!settings.demo || userSettings.isSuperAdmin) && (
                    <Button className="w-full mb-2" onClick={() => handleNavigate('new')}>
                        {i18n.translate({ id: 'button', sourceName: 'Models' })}
                    </Button>
                )}
            </div>
            <div className="hidden md:block">
                <AdminViewHeader
                    gridCols={GRID_COLS}
                    cols={{
                        cols: [
                            {
                                text: i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' }),
                            },
                        ],
                        button:
                            !settings.demo || userSettings.isSuperAdmin
                                ? {
                                      text: i18n.translate({ id: 'button', sourceName: 'Models' }),
                                      function: () => handleNavigate('new'),
                                  }
                                : undefined,
                    }}
                />
                <hr className="border-layout-borderColor mt-5" />
            </div>
            <PaginationWrapper
                listType={PaginationListType.Models}
                itemsFunction={modelService.getModelsByPage}
                itemsPerPage={15}
                query={query || null}
                renderItem={(model: Model, index: number) => (
                    <AdminViewContent
                        key={model.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={model.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: model.title,
                                    image: model.image,
                                    showImage: true,
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'primaryRound'
                                                : 'disabledRound',
                                        onClick: () =>
                                            (!settings.demo || userSettings.isSuperAdmin) &&
                                            handleNavigate(model.identifier),
                                        icon: <PencilSimple />,
                                    },
                                    {
                                        variant:
                                            model.hasPrompts || (settings.demo && !userSettings.isSuperAdmin)
                                                ? 'disabledRound'
                                                : 'secondaryRound',
                                        onClick: () =>
                                            !model.hasPrompts && !settings.demo
                                                ? ModelsActions.handleOpenConfirmDialog(model.identifier)
                                                : null,
                                        icon: <Trash />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            />
        </>
    );
}

export default ChatModels;
